<template>
  <div class="two-Cards">
    <el-tabs
      v-model="mydata.activeName"
      class="demo-tabs"
      @tab-click="handleClick"
    >
      <el-tab-pane :label="props.titleL" name="first">
        <div
          class="blue-box"
          @click="mydata.showTop = 'blue'"
          :class="mydata.showTop === 'blue' ? 'zindex' : ''"
        >
          <!-- <p>{{ props.titleL }}</p> -->
          <div class="my-box ele-have-scrollbar">
            <writingCards
              v-for="(item, index) in props.dataArrL"
              :key="index"
              :info="item"
            ></writingCards>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="props.titleR" name="second">
        <div
          class="red-box"
          @click="mydata.showTop = 'red'"
          :class="mydata.showTop === 'red' ? 'zindex' : ''"
        >
          <!-- <p>{{ props.titleR }}</p> -->
          <div class="my-box ele-have-scrollbar">
            <writingCards
              v-for="(item, index) in props.dataArrR"
              :key="index"
              :info="item"
            ></writingCards>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import writingCards from "./components/writingCards.vue";
import { reactive, ref, toRaw } from "vue";
//swiper start//////////////////////////////////////////////////////////////////////////////////////////////
// 引入swiper插件
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Mousewheel,
} from "swiper/modules";

// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// 创建功能模块
let modules = [
  Autoplay,
  Navigation,
  // Pagination,
  Scrollbar,
  A11y,
  Mousewheel,
];
//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
// 事件处理器
const onSwiper = (swiper) => {
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
// 点击右箭头
const rightClick = () => {
  swiperNew.slidePrev();
};
// 点击左箭头
const leftClick = () => {
  swiperNew.slideNext();
};
// 单元块滑动
const onSlideChange = () => {};
// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

//   // 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// // 创建功能模块
// let modules_2 = [Autoplay, Navigation, Pagination, Scrollbar, A11y];
// //定义swiperNew,目的获取非响应式swiper
// let swiperNew_2 = null;
// // 事件处理器
// const onSwiper_2 = (swiper) => {
//   swiperNew_2 = toRaw(swiper); //拿到swiper对象再转换为非响应式
// };
// //鼠标移入
// const enter_2 = () => {
//   swiperNew_2.autoplay.stop();
// };
// //鼠标移出
// const leave_2 = () => {
//   swiperNew_2.autoplay.start();
// };
// // 点击右箭头
// const rightClick_2 = () => {
//   swiperNew_2.slidePrev();
// };
// // 点击左箭头
// const leftClick_2 = () => {
//   swiperNew_2.slideNext();
// };
// // 单元块滑动
// const onSlideChange_2 = () => {};
//   // 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

//swiper end//////////////////////////////////////////////////////////////////////////////////////////////

const mydata = reactive({
  activeName: "first",
  showTop: "blue",
  // currentPage3:"5",
  // pageSize3:"100",
  // small:false,
  // background:false,
  // disabled:false,
  active: "",
  titles1: "专题类",
  titles2: "汇编类",
  titles3: "专项类",

  buttonTitle: ["原创卷", "学考类", "同步类", "工具类"],
  // 图片数组
  imgArr: [
    {
      img: require("@/assets/Frame 2113 1.png"),
    },
    {
      img: require("@/assets/Frame 2113 1.png"),
    },
    {
      img: require("@/assets/Frame 2113 1.png"),
    },
    {
      img: require("@/assets/Frame 2113 1.png"),
    },
    {
      img: require("@/assets/Frame 2113 1.png"),
    },
    {
      img: require("@/assets/Frame 2113 1.png"),
    },
  ],
});

const props = defineProps({
  dataArrL: {
    type: Array,
    default: () => {
      return [];
    },
  },
  dataArrR: {
    type: Array,
    default: () => {
      return [];
    },
  },
  titleL: {
    type: String,
    default: "真题类",
  },
  titleR: {
    type: String,
    default: "真题汇编",
  },
});
</script>

<style scoped lang="scss">
.two-Cards {
  width: 343px;
  margin: 0 auto;
  // border: 1px solid rgb(4, 0, 255);
  // background-color: #ffffff;
  margin-top: 30px !important;

  // 目录的内容
  :deep(.demo-tabs > .el-tabs__content) {
    // padding: 30px;
    // border: 1px solid red;
    width: 343px;

    // margin: 0px;
    margin: 0 auto;
    margin-top: 18px;
  }
  ////整体目录list
  :deep(.el-tabs__header.is-top) {
    // width:1200px;
    // height: 50px;
    margin-bottom: 0px;
    // border:1px solid red;
    display: flex;
    // justify-content: center;
    width: 343px;
    margin: 0 auto;
  }
  /////整个tabs
  :deep(.el-tabs.el-tabs--top.demo-tabs) {
    // border:1px solid rgb(9, 255, 0);
    //  background-color: transparent;
  }
  //////每个字体
  :deep(.el-tabs__item.is-top) {
    // width: 64px;
    // height: 32px;
    text-align: center;
    padding: 0px;
    font-size: 18px;
    font-weight: 700;
    color: #333333;
    // border: 1px solid red;
  }
  // :deep(.el-tabs__item.is-top:hover) {
  //   color: #333333;
  // }
  ///////整体宽度的宽度
  :deep(.el-tabs__nav.is-top) {
    // border: 1px solid rgb(0, 255, 0);
    // width: 1915px;
    width: 343px;
    height: 50px;
    display: flex;
    justify-content: space-between;

    align-items: center;
    margin: 0 auto;
  }

  :deep(.el-tabs__nav-scroll) {
    // border: 1px solid blue;
    width: 200px;
    display: flex;
    // justify-content: space-between;
    // background-color: red;
  }
}
.blue-box,
.red-box {
  width: 343px;
  // height: 754px;
  // border:1px solid blue;
  // background-color: #009de0;
  background: linear-gradient(180deg, #08aa3d 0%, #1fcf5a 100%);

  border-radius: 20px;
  overflow: hidden;
  padding:16px;
  // > p {
  //   font-size: 24px;
  //   font-weight: 700;
  //   letter-spacing: 1px;
  //   line-height: 28px;
  //   color: #ffffff;
  //   text-align: center;
  //   margin-top: 30px;
  //   margin-bottom: 21px;
  // }
  > div {
    // width: 580px;
    height: 415px;
    // border:1px solid blue;
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow: 0px 4px 4px 0px;
    // margin: 0px 30px;
    padding: 10px;
    // padding-right: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.blue-box {
  // position: absolute;
  // top: 30px;
  // left: 0px;
  // z-index: 1;
}
.red-box {
  //  background-color: #ffffff;
  background: linear-gradient(180deg, #fe2e01 0%, #ff986f 100%);
  // position: absolute;
  // right: 0px;
}
.zindex {
  z-index: 999;
}
.my-box {
  // border: 1px solid red;
  overflow-y: auto;
  overflow-x: hidden;

  :deep(.box-writing) {
    // height:172px;
    // border:1px solid rgb(30, 0, 255);
    margin-bottom:16px;
    > div:nth-of-type(1) {
      // width: 134px;
      // height: 134px;
      // img {
      //   width: 90px;
      //   height: 120px;
      //   margin-left: 40px;
      //   margin-top: 25px;
      // }
    }
    > div:nth-of-type(2) {
      //  border:1px solid red;
      width: 155px;
      > p:nth-of-type(1) {
        // width:287px;
        width: 100%;
        // border:1px solid red;
      }
      > p:nth-of-type(2) {
        // width:287px;
        width: 155px;
        // border:1px solid red;
      }
    }
  }

  :deep(.box-writing):last-of-type{
    margin-bottom:0px;
  }
}
</style>
